import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { formatDateTime, formatRelativeTime } from 'nallian-shared-ui/lib/lib/dateTime';
import { Loader, Grid, Table, Header, Flex, Icon } from 'nallian-shared-ui/lib/components';
import CopyToClipboard from '../../../app/components/CopyToClipboard';

const RoleDetails = ({ role, isLoading }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return <Loader active inline="centered" />;
  }

  if (!role) return null;

  return (
    <Grid columns={2} stackable>
      <Grid.Column>
        <Header>{t('general')}</Header>
        <Table>
          <Table.Row>
            <Table.HeaderCell width={4}>{t('name')}</Table.HeaderCell>
            <Table.Cell>{role.name}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('description')}</Table.HeaderCell>
            <Table.Cell>{role.description || '-'}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('tag')}</Table.HeaderCell>
            <Table.Cell>{role.tag || '-'}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('isObsolete')}</Table.HeaderCell>
            <Table.Cell>
              <Icon
                name={role.isObsolete ? 'checkmark' : 'minus'}
                color={role.isObsolete ? 'green' : 'gray'}
              />
            </Table.Cell>
          </Table.Row>
        </Table>
        <Header>{t('metaData')}</Header>
        <Table>
          <Table.Row>
            <Table.HeaderCell width={4}>{t('createdOn')}</Table.HeaderCell>
            <Table.Cell>
              {`${formatDateTime(role.createdOn)}`}
              &nbsp;-&nbsp;
              {formatRelativeTime(role.createdOn)}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('lastModifiedOn')}</Table.HeaderCell>
            {role.modifiedOn ? (
              <Table.Cell>
                {`${formatDateTime(role.modifiedOn)}`}
                &nbsp;-&nbsp;
                {formatRelativeTime(role.modifiedOn)}
              </Table.Cell>
            ) : (
              <Table.Cell />
            )}
          </Table.Row>
        </Table>
      </Grid.Column>
      <Grid.Column>
        <Header>{t('data')}</Header>
        <Table>
          <Table.Row>
            <Table.HeaderCell width={4}>{t('id')}</Table.HeaderCell>
            <Table.Cell>
              <Flex fluid alignItems="center" justifyContent="space-between">
                {role.id}
                <CopyToClipboard value={role.id} />
              </Flex>
            </Table.Cell>
          </Table.Row>
        </Table>
      </Grid.Column>
    </Grid>
  );
};

RoleDetails.propTypes = {
  role: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default RoleDetails;
